import { catalogueDate } from './catalogue-analytics';
import { newsSubCategory, newsTopicsOf, NEWS_TOPICS } from './news-topics';
/** bb = BB's own articles; tech / business = the scraped feeds, split exactly
 *  like the /news top tabs (shared newsSubCategory). */
export function newsOrigin(article: { category?: string; source?: string; subCategory?: string }) {
  if (article.category !== 'industry' && !article.source?.startsWith('industry-rss:')) return 'bb';
  return newsSubCategory({ ...article, category: 'industry' }) === 'music-tech' ? 'tech' : 'business';
}
export function selectHomeNews<T extends { id: string; status?: string; category?: string; source?: string; subCategory?: string; topics?: unknown; title?: string; excerpt?: string; publishedAt?: unknown; createdAt?: unknown }>(articles: T[], perOrigin = 100): T[] {
  const published = articles.filter(a => !a.status || a.status === 'published').sort((a, b) => (catalogueDate(b.publishedAt)?.getTime() || catalogueDate(b.createdAt)?.getTime() || 0) - (catalogueDate(a.publishedAt)?.getTime() || catalogueDate(a.createdAt)?.getTime() || 0));
  const selected = new Map<string, T>();
  for (const origin of ['bb', 'tech', 'business']) {
    for (const article of published.filter(a => newsOrigin(a) === origin).slice(0, perOrigin)) selected.set(article.id, article);
  }
  // The DAW / Open Source chips need their own newest stories — the busy
  // general feeds would otherwise push them out of the per-origin slices.
  for (const topic of NEWS_TOPICS) {
    for (const article of published.filter(a => newsTopicsOf(a).includes(topic)).slice(0, perOrigin)) selected.set(article.id, article);
  }
  return [...selected.values()];
}
